import React, {Dispatch, FC, SetStateAction, useEffect, useState} from 'react';
import {useSimulation} from '../../../../../providers/Typing/SimulationProvider';
import {useSimulationCclt} from '../../../../../providers/Typing/SimulationCcltProvider';
import InformInstallmentValues from '../../../../InformInstallmentValues/InformInstallmentValues';
import FilterSimulationBase from '../../FilterSimulationBase/FilterSimulationBase';

interface FilterSimulationCcltProps {
    type?: 'first' | 'filter' | 'preview';
    setIsRetrying?: Dispatch<SetStateAction<boolean>>;
}

const FilterSimulationCclt: FC<FilterSimulationCcltProps> = ({type, setIsRetrying}) => {
    const [indexSimulation, setIndexSimulation] = useState<number>(-1);
    const {isLoadingCard, listPreview} = useSimulation();
    const {
        valueCclt,
        setValueCclt,
        installmentsCclt,
        setInstallmentsCclt,
        valueMaximumCclt,
        setValueMaximumCclt,
        valueMinimumCclt,
        installmentsPossibleCclt,
        simulateCclt,
        retrySimulate,
        installmentsPossibleValuesCclt,
    } = useSimulationCclt();

    useEffect(() => {
        if (type === 'preview') {
            const auxIndex = listPreview?.findIndex((x: any) => x.data?._produto === 'cclt');
            auxIndex != undefined && auxIndex >= 0 && setIndexSimulation(auxIndex);
        }
    }, []);

    useEffect(() => {
        if (installmentsPossibleValuesCclt?.length > 0) {
            setValueMaximumCclt(
                installmentsPossibleValuesCclt.find((x: any) => x.installment === installmentsCclt)?.value
            );
        }
    }, [installmentsCclt]);

    const handleAction = async () => {
        if (type === 'preview' && !!setIsRetrying) {
            setIsRetrying(true);
            await retrySimulate(
                listPreview[indexSimulation]?.data?._financeira,
                valueCclt,
                installmentsCclt,
                'preview',
                indexSimulation
            );

            setIsRetrying(false);
            return;
        }
        await simulateCclt(true);
    };

    return (
        <div className="FilterSimulationCclt" data-testid="FilterSimulationCclt">
            <FilterSimulationBase keepOpen={type === 'preview'}>
                <InformInstallmentValues
                    installments={installmentsCclt}
                    setInstallments={setInstallmentsCclt}
                    value={valueCclt}
                    setValue={setValueCclt}
                    installmentsMaximum={installmentsPossibleCclt}
                    showInstallment={true}
                    showValue={true}
                    labelValue="Valor da margem"
                    valueMinimum={valueMinimumCclt}
                    valueMaximum={valueMaximumCclt}
                    showValueMaximum={true}
                    disabledSimulate={isLoadingCard !== ''}
                    actionSimulate={() => handleAction()}
                    resetValueOnChangeInstallments={true}
                />
            </FilterSimulationBase>
        </div>
    );
};

export default FilterSimulationCclt;

